import React, { memo } from "react";
import { Center,  Flex, Text, Divider } from "@chakra-ui/react";
export default memo(function WhyComponent() {
   return (
      <>
         <Center w={'1280px'} mt={'840px'} mx={'auto'}>
            <Text fontSize={34}  color={'green.500'} mr={'17px'}>
               Why 
            </Text>
            <Text fontSize={34} >
                is AlohaBots developed?
            </Text>
         </Center>
         <Flex flexDir={"row"} mt={"87px"} w={"1280px"} mx={'auto'}>
            <Flex flexDir={"column"} flex={1}>
               <Flex alignItems={"center"} userSelect='none'>
                  <Text  fontSize={24}  w={'62px'} h={'62px'} borderRadius={'full'}  lineHeight={'62px'} textAlign='center' boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'} fontFamily={'Arial-BoldMT'} color={'green.500'}>
                     01
                  </Text>
                  <Divider color={'#B6ECDB'}/>
               </Flex>
               <Text mr={"47px"} mt={"47px"} fontSize={20} color={"#333"}>
               Most of new NFT projects have low community engagement. Project community members are not able to spread the latest updates.                </Text>
            </Flex>
            <Flex flexDir={"column"} flex={1}>
               <Flex alignItems={"center"} userSelect='none'>
                  <Text fontSize={24}  w={'62px'} h={'62px'} borderRadius={'full'}  lineHeight={'62px'}  textAlign='center' boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'}  fontFamily={'Arial-BoldMT'} color={'green.500'}>
                     02
                  </Text>
                  <Divider color={'#B6ECDB'}/>
               </Flex>
               <Text mr={"47px"} mt={"47px"} fontSize={20} color={"#333"}>
               All successful NFT projects make good use of their own sales bots on Twitter, including BAYC.               </Text>
            </Flex>
            <Flex flexDir={"column"} flex={1}>
               <Flex alignItems={"center"} userSelect='none'>
                  <Text fontSize={24}  w={'62px'} h={'62px'} borderRadius={'full'}  lineHeight={'62px'} textAlign='center' boxShadow={'0px 10px 50px 0px rgba(246,248,252,1)'} fontFamily={'Arial-BoldMT'} color={'green.500'}>
                     03
                  </Text>
                  <Divider color={'#B6ECDB'}/>
               </Flex>
               <Text mr={"47px"} mt={"47px"} fontSize={20} color={"#333"}>
               Sales bots available in the market are not satisfactory, yet developing your own sales bot requires large amount of resources.
               </Text>
            </Flex>
         </Flex>
      </>
   );
});
